module.exports = __webpack_public_path__ + "img/img-alt.f72be964.svg";